import { Component, EventEmitter, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-maintenance-confirmable-action',
    templateUrl: './maintenance-confirmable-action.component.html',
    styleUrls: ['./maintenance-confirmable-action.component.scss'],
  imports: [TranslatePipe]
})
export class MaintenanceConfirmableActionComponent {

  @Output() public readonly confirmedClick = new EventEmitter<void>();

  protected confirmation = false;

}
